<script setup lang="ts">
import WebsiteLayout from "@layouts/website-layout.vue";
import { usePage } from "@inertiajs/vue3";
import { PagePropsInterface } from "@interfaces/PagePropsInterface.js";
import { defineAsyncComponent, onMounted, PropType } from "vue";
import LandingHeader from "./sections/landing-header.vue";
import DividerComponent from "@components/divider.vue";
import { ProductsInterface } from "@interfaces/ProductsInterface.js";
import Products from "./sections/products.vue";
import AppHead from "@layouts/sections/app-head.vue";

let page = usePage<PagePropsInterface>();

const props = defineProps({
    header: {
        type: Object as { title: string; description: string },
        required: true,
    },
    preConfigs: {
        type: Array as PropType<ProductsInterface[]>,
        required: true,
    },
    categorySlug: {
        type: String,
        required: true,
    },
    name: {
        type: Object as { singular: string; plural: string },
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
});

defineOptions({
    layout: WebsiteLayout,
});

onMounted(() => {
    page.props.headerOptions = {
        transparent: true,
        inverted: false,
    };
});

const App = defineAsyncComponent(()=> import('./sections/app.vue'));
const WhyLevelup = defineAsyncComponent(()=> import('./sections/why-levelup.vue'))
const Testimonial = defineAsyncComponent(()=> import('./sections/testimonial.vue'))
</script>
<template>
    <AppHead :title="header.title" :description="header.description"></AppHead>
    <div id="page-landing">
        <landing-header :title="header.title" :description="header.description">
        </landing-header>
        <divider-component class="container" />
        <products
            :name="props.name"
            :categorySlug="props.categorySlug"
            :preConfigs="props.preConfigs"
        >
        </products>
        <app :name="props.name"></app>
        <why-levelup :type="props.type" :name="props.name"></why-levelup>
        <testimonial></testimonial>
    </div>
</template>
<style scoped lang="scss">
@use "@scss/pages/landing/landing";
</style>
